import { useAuth } from '../contexts/AuthContext';

export const PendingApproval = () => {
  const { signOut, profile } = useAuth();

  return (
    <div className="mx-auto max-w-md rounded-lg border border-yellow-200 bg-yellow-50 p-6 shadow-sm text-yellow-900">
      <h1 className="mb-2 text-xl font-bold">Account Under Review</h1>
      <p className="mb-4 text-sm">
        Your registration is currently under review. An employee or admin will approve it shortly.
      </p>
      <p className="mb-4 text-sm">
        If you need help, please use the <strong>Contact Us</strong> link on the home page or footer.
      </p>
      {profile?.email && (
        <p className="mb-4 text-sm">
          <strong>Email:</strong> {profile.email}
        </p>
      )}
      <button
        onClick={() => signOut()}
        className="w-full rounded bg-yellow-600 px-4 py-2 text-sm font-medium text-white hover:bg-yellow-700"
      >
        Logout
      </button>
    </div>
  );
};
